import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import LayoutApp from '../layouts/Layout';
import AuctionItem from '../modules/auction/online-auction/auction-item/AuctionItem';
import AuctionList from '../modules/auction/online-auction/auction-list/Index';
import { isTokenExpired } from '../modules/common/ts/CommonFunctions';
import EventDetail from '../modules/event/event-detail/Index';
import Event from '../modules/event/event-list/Index';
import Home from '../modules/home/Index';
import Intro from '../modules/intro/Index';
import { setToken, setUser } from '../modules/login/redux/LoginSlice';
import ProcedureDetail from '../modules/procedure/procedure-detail/Index';
import ProcedureList from '../modules/procedure/procedure-list/Index';
import Profile from '../modules/profile/detail/Index';
import { useLazyGetUserInfoQuery } from '../redux/api/AccountApi';
import { useAppDispatch } from '../redux/Hooks';
import PrivateRoute from './PrivateRoute';
import ContactUs from '../modules/contact-us/Index';
import AuctionListOther from '../modules/auction/other-auction/auction-list-other/Index';
import AuctionItemOther from '../modules/auction/other-auction/auction-item-other/AuctionItemOther';
import ProductCare from '../modules/profile/product-care/Index';
import PrepayList from '../modules/profile/prepay/Index';
import AuctionHistoryList from '../modules/profile/auction-history/Index';
import AuctionRegisterList from '../modules/auction/register/Index'; 
import AuctionRegisterHistory from '../modules/profile/auction-register-history/Index';

const icon = <LoadingOutlined style={{ fontSize: 24 }} spin />

const IndexRoutes = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(true);
    const [trigger] = useLazyGetUserInfoQuery();

    useEffect(() => {
        if (isTokenExpired(localStorage.getItem("accessToken") || "")) {
            dispatch(setUser({}));
            dispatch(setToken(""));
            setLoading(false);
        } else {
            trigger({}).unwrap().then(res => {
                dispatch(setUser(res))
                dispatch(setToken(localStorage.getItem("accessToken")));
                setLoading(false);
            }).catch(err => {
                setLoading(false);
            })
        }
    }, [dispatch, trigger])

    return (
        <>
            <Routes>
                {/* <Route path='/login' element={<Login />} />
                <Route path="/" element={<PrivateRoute><LayoutApp /></PrivateRoute>}>
                </Route> */}
                <Route path='/' element={<Spin
                    spinning={loading}
                    indicator={icon}
                    wrapperClassName='custom-spin'>
                    <LayoutApp />
                </Spin>}>
                    <Route path='' element={<Home />} />
                    {/*Kích hoạt tài khoản, redirect về trang chủ*/}
                    <Route path='/account-managers/:token' element={<Home />} />

                    <Route path='/auction-list' element={<AuctionList />} />
                    <Route path='/auction-list/upcoming' element={<AuctionList />} />
                    <Route path='/auction-list/ongoing' element={<AuctionList />} />
                    <Route path='/auction-list/finish' element={<AuctionList />} />
                    <Route path='/auction-item/:id/:statuteId' element={<AuctionItem />} />

                    <Route path='/auction-list-other' element={<AuctionListOther />} />
                    <Route path='/auction-item-other/:id/:statuteId' element={<AuctionItemOther />} />

                    <Route path='/auction-register' element={<PrivateRoute><AuctionRegisterList /></PrivateRoute>} />

                    <Route path='/intro' element={<Intro />} />

                    <Route path='/event' element={<Event />} />
                    <Route path='/event/:id' element={<EventDetail />} />

                    <Route path='/contact-us' element={<ContactUs />} />

                    <Route path='/procedure' element={<ProcedureList />} />
                    <Route path='/procedure/:id' element={<ProcedureDetail />} />

                    <Route path='/profile' element={<PrivateRoute><Profile /></PrivateRoute>} />
                    <Route path='/profile/detail' element={<PrivateRoute><Profile /></PrivateRoute>} />
                    <Route path='/profile/detail/:redirect' element={<PrivateRoute><Profile /></PrivateRoute>} />
                    <Route path='/profile/auction-history' element={<PrivateRoute><AuctionHistoryList /></PrivateRoute>} />
                    <Route path='/profile/product-care' element={<PrivateRoute><ProductCare /></PrivateRoute>} />
                    <Route path='/profile/prepay-list' element={<PrivateRoute><PrepayList /></PrivateRoute>} />
                    <Route path='/profile/auction-register-history' element={<PrivateRoute><AuctionRegisterHistory /></PrivateRoute>} />
                </Route>
            </Routes>
        </>
    );
}

export default IndexRoutes;
